export default __webpack_public_path__ + "static/media/music-group.fe1da4da.webp";